import { IconProps } from "../types/types";

export const PlayIcon = ({
  className = "fill-white",
  size,
  color,
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
      className={className}
      style={{ fill: color }}
    >
      <path
        d="M0 28C0 12.536 12.536 0 28 0s28 12.536 28 28-12.536 28-28 28S0 43.464 0 28"
        fill="#fffff"
        className="!fill-white"
      />
      <path d="M18.004 12.73a1.77 1.77 0 0 0-1.66-.05c-.257.128-.47.315-.619.542a1.36 1.36 0 0 0-.225.748v28.17c.02.254.114.498.27.71.158.21.373.382.625.495a1.78 1.78 0 0 0 1.609-.078l21.908-14.085.434-.505.154-.622-.154-.622-.434-.505z" />
    </svg>
  );
};
